module.exports = __webpack_public_path__ + "img/wodeyuyue.006400dd.png";